import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    // @ts-expect-error Prop exists
    justifyContent: ({ isYours }) => (isYours ? 'flex-end' : 'flex-start'),
    margin: '1.25rem 78px'
  },

  holder: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0.705rem',
    boxSizing: 'border-box',
    padding: '0.5rem',
    // @ts-expect-error Prop exists
    backgroundColor: ({ isYours }) =>
      isYours ? theme.palette.primary.main : 'white'
  },

  frame: {
    border: 'none',
    boxSizing: 'border-box',
    borderRadius: 'calc(0.705rem - 0.5rem)'
  }
}))

export default useStyles
